import { requestBuilder } from '../../http/RequestBuilder';
import type { IManualAccount } from '../types/ManualAccount';

export interface CreateManualAccountBody {
    userId: string;
    membershipId: string;
    institutionName?: string;
    name: string;
    amount: number;
    holisticCategory: string;
    type?: string | null;
    isHidden?: boolean;
    minimumPayment?: number | null;
    interestRate?: number | null;
    description?: string | null;
}

const useCreateManualAccount = requestBuilder.mutation<
    Partial<IManualAccount>,
    CreateManualAccountBody
>({
    endpoint: '/api/manual-accounts/create',
    method: 'POST',
});

export default useCreateManualAccount;
